import { render } from "./TeoMenu.vue?vue&type=template&id=fbd7d1be&scoped=true"
import script from "./TeoMenu.vue?vue&type=script&lang=js"
export * from "./TeoMenu.vue?vue&type=script&lang=js"

import "./TeoMenu.vue?vue&type=style&index=0&id=fbd7d1be&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fbd7d1be"]])

export default __exports__